import { schema } from 'normalizr';
import productCategorySchema from './productCategorySchema';
import tagSchema from './tagSchema';

export default new schema.Entity('products', {
  categories: [productCategorySchema],
  tags: [tagSchema],
});
